import axios from "axios";
import React, {useEffect, useState} from 'react'
import Footer from "./parts/footer";
import CustomGallery from "./gallery/gallery";
import Formats from "./formats/formats";
import AdvantagesOne from "./advantages/advantages";
import Awarding from "./awarding/awarding";
import EbAutOne from "./ebaut-event/ebaut";
import Header from "./parts/header";
import EventThemesBase from "./themes/themes-base";
import EventSpeacersBase from "./speacers/speacers-base"
import EventPartnersBase from "./partners/partners-base"
import PartnersTopNew from "./partners/partners-top-new"
import EventPanelBase from "./panel/panel-base";
import EventProgram from "./program/program-accordion"
import FirstScreen from "./first-screen/firstscreen";
import EventOrganizers from "./organizers/organizers"
import EventVideo from "./video/video"
import OldSpeacers from "./speacers/speacers-old";
import Statistic from "./statistic/statistic";
import Quotes from "./speaker-quotes/quotes";
import EventPanelNew from "./panel/panel-new";
import News from "./news/news";


function Home() {

    const [post, setPosts] = useState([]);
    const [contentReady, setContentReady] = useState(false);

    const fetchPosts = () => {
        axios
            .get('https://ekonomika.ua/wp-json/wp/v2/events/4510?_fields=acf&acf_format=standard')
            .then((res) => {
                setPosts(res.data.acf || {});
            })
            .catch(() => {
                // Секція тем статична, тому доскрол має спрацювати і без даних ACF.
            })
            .finally(() => {
                setContentReady(true);
            });
    }

    useEffect(() => {
        fetchPosts()
    }, [post.data])

    useEffect(() => {
        if (!contentReady) return;

        const hash = window.location.hash;
        if (!hash) return;

        const id = decodeURIComponent(hash.replace(/^#/, ''));
        let attempts = 0;
        let frameId;
        let timeoutId;
        let stopped = false;

        const scrollToHash = () => {
            if (stopped) return false;
            const target = document.getElementById(id);
            if (!target) return false;

            const headerOffset = 80;
            const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
            window.scrollTo({ top: Math.max(top, 0), behavior: 'auto' });
            return true;
        };

        const stopRetry = () => {
            stopped = true;
            window.clearTimeout(timeoutId);
        };

        const retryScroll = () => {
            if (stopped) return;
            scrollToHash();
            attempts += 1;
            if (attempts < 12) {
                timeoutId = window.setTimeout(retryScroll, 250);
            }
        };

        frameId = window.requestAnimationFrame(() => {
            frameId = window.requestAnimationFrame(retryScroll);
        });

        const onImageSettled = () => scrollToHash();
        const images = Array.from(document.images).filter((img) => !img.complete);
        images.forEach((img) => {
            img.addEventListener('load', onImageSettled);
            img.addEventListener('error', onImageSettled);
        });
        window.addEventListener('load', onImageSettled);
        window.addEventListener('wheel', stopRetry, { passive: true });
        window.addEventListener('touchstart', stopRetry, { passive: true });

        return () => {
            window.cancelAnimationFrame(frameId);
            window.clearTimeout(timeoutId);
            window.removeEventListener('load', onImageSettled);
            window.removeEventListener('wheel', stopRetry);
            window.removeEventListener('touchstart', stopRetry);
            images.forEach((img) => {
                img.removeEventListener('load', onImageSettled);
                img.removeEventListener('error', onImageSettled);
            });
        };
    }, [contentReady, post])

    let advantagesData = post.advantages
    let ebautData = post.ebaut_event
    let fsData = post.fs_group
    let formatsData = post.formats
    let myGallery = post.gallery
    let awardingData = post.awarding
    let speacersData = post.speacers
    let partnersBaseData = post.partners_bottom
    let partnersTopData = post.partners_top_new
    let panelData = post.panel
    let themesData = post.theme
    let programData = post.program

    return (
        <>
            <Header/>
            <FirstScreen fsData={fsData} />
            <Statistic />
            <Quotes />

            <EbAutOne ebautData={ebautData} />
            <CustomGallery myGallery={myGallery} />
            <EventThemesBase />
            <EventSpeacersBase speacersData={speacersData} />
            <EventProgram programData={programData} />
            <Formats formatsData={formatsData} />
            <News />
            {<EventOrganizers/>}



            {/*<AdvantagesOne advantagesData={advantagesData} />*/}
            {/*<EventPanelNew />*/}
            {/*<OldSpeacers />*/}
            {/*<EventPanelBase panelData ={panelData}  />*/}
            {/*<Awarding awardingData={awardingData} />*/}
            
            {/*<PartnersTopNew partnersTopData={partnersTopData} />*/}

            <EventPartnersBase partnersBaseData={partnersBaseData}/>
            <Footer />
        </>
    )
}

export default Home;